<template>
  <v-dialog
    :model-value="modelValue"
    max-width="440"
    persistent
    :z-index="10200"
    content-class="ltcs-request-confirm-dialog"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <div class="ltcs-request-confirm">
      <div class="ltcs-request-confirm__header">
        <v-icon size="22" color="#1e3a5f">mdi-send-check</v-icon>
        <h3>자료요청 확인</h3>
        <button
          type="button"
          class="ltcs-request-confirm__close"
          aria-label="닫기"
          :disabled="loading"
          @click="emit('update:modelValue', false)"
        >
          <v-icon size="18">mdi-close</v-icon>
        </button>
      </div>

      <div class="ltcs-request-confirm__body">
        <p class="confirm-lead">아래 조건으로 롱텀케어에 요청합니다. 연월이 맞는지 확인해 주세요.</p>

        <dl class="param-list">
          <div class="param-row">
            <dt>요청 유형</dt>
            <dd>{{ typeName || '-' }}</dd>
          </div>
          <div v-if="facilityName" class="param-row">
            <dt>시설명</dt>
            <dd>{{ facilityName }}</dd>
          </div>
          <template v-if="needsYearMonth">
            <div class="param-row param-row--emphasis">
              <dt>조회 연월</dt>
              <dd>
                <span class="ym-label">{{ yearMonthLabel }}</span>
                <span class="ym-code" title="서버로 전송되는 연월 값">{{ yearMonth || '-' }}</span>
              </dd>
            </div>
            <div class="param-row">
              <dt>사업구분</dt>
              <dd>{{ bizGubun || '미선택' }}</dd>
            </div>
          </template>
          <div v-else class="param-row">
            <dt>조회 연월</dt>
            <dd class="muted">해당 없음 (전체 조회)</dd>
          </div>
        </dl>
      </div>

      <div class="ltcs-request-confirm__actions">
        <v-btn variant="text" class="btn-cancel" :disabled="loading" @click="emit('update:modelValue', false)">
          취소
        </v-btn>
        <v-spacer />
        <v-btn variant="flat" class="btn-register" :loading="loading" @click="emit('confirm')">
          <v-icon size="16" class="mr-1">mdi-send</v-icon>
          요청 보내기
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    typeName?: string;
    yearMonth?: string;
    bizGubun?: string;
    facilityName?: string;
    needsYearMonth?: boolean;
    loading?: boolean;
  }>(),
  {
    typeName: '',
    yearMonth: '',
    bizGubun: '',
    facilityName: '',
    needsYearMonth: true,
    loading: false,
  }
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'confirm'): void;
}>();

const yearMonthLabel = computed(() => {
  const ym = props.yearMonth || '';
  if (ym.length !== 6) return ym || '-';
  return `${ym.slice(0, 4)}년 ${parseInt(ym.slice(4, 6), 10)}월`;
});
</script>
